var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0","rounded":"lg"}},[_c('v-tabs',{class:{
     'd-flex': _vm.center,
     'align-center': _vm.center,
     'justify-center': _vm.center
    },attrs:{"hide-slider":"","show-arrows":""},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((_vm.list),function(tab,i){return _c('v-tab',{key:i,staticClass:"ma-1",class:{
        'compact-tabs': _vm.compact
      },on:{"click":function($event){return _vm.clickOnTab(tab)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }